import React from 'react';
import { Menu, Moon, Sun, Bell } from 'lucide-react';
import { getNavItem } from './adminNavConfig';
import './AdminLayout.css';

const AdminTopbar = ({
    selectedSection,
    onToggleMobileSidebar,
    theme,
    onToggleTheme,
    pendingSuggestions = 0,
    onOpenSuggestions,
}) => {
    const navItem = getNavItem(selectedSection);
    const sectionLabel = navItem?.label || 'Inicio';
    const groupLabel = navItem?.groupLabel || 'Resumen';

    return (
        <header className="admin-topbar">
            <button
                type="button"
                className="admin-topbar__mobile-toggle"
                onClick={onToggleMobileSidebar}
                aria-label="Abrir menú"
            >
                <Menu size={20} />
            </button>

            <div className="admin-topbar__breadcrumb">
                <span className="admin-topbar__crumb-muted">Panel de Administración</span>
                <span className="admin-topbar__crumb-sep">/</span>
                <span className="admin-topbar__crumb-muted">{groupLabel}</span>
                <span className="admin-topbar__crumb-sep">/</span>
                <span className="admin-topbar__crumb-current">{sectionLabel}</span>
            </div>

            <div className="admin-topbar__actions">
                {pendingSuggestions > 0 && (
                    <button
                        type="button"
                        className="admin-topbar__icon-btn admin-topbar__icon-btn--with-badge"
                        onClick={onOpenSuggestions}
                        title={`${pendingSuggestions} sugerencias sin leer`}
                        aria-label={`${pendingSuggestions} sugerencias sin leer`}
                    >
                        <Bell size={18} />
                        <span className="admin-topbar__badge">{pendingSuggestions > 99 ? '99+' : pendingSuggestions}</span>
                    </button>
                )}

                <button
                    type="button"
                    className="admin-topbar__icon-btn"
                    onClick={onToggleTheme}
                    title={`Cambiar a tema ${theme === 'dark' ? 'claro' : 'oscuro'}`}
                    aria-label={`Cambiar a tema ${theme === 'dark' ? 'claro' : 'oscuro'}`}
                >
                    {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
                </button>
            </div>
        </header>
    );
};

export default AdminTopbar;
